import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { ForumTopicPost } from "../models/forumTopicPost";
import api from "./api";

export async function getForumTopicPosts(forumTopicId: number, forumId: number, clubId: number): Promise<ForumTopicPost[]> {
  const baseUrl = environment.api.forumTopicPost.getByForumTopic
    .replace('{clubId}', String(clubId))
    .replace('{forumId}', String(forumId))
    .replace('{forumTopicId}', String(forumTopicId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function createForumTopicPost(payload: ForumTopicPost, clubId: number, forumId: number, forumTopicId: number, userId: number): Promise<AsyncResult<ForumTopicPost>> {
  let baseUrl = environment.api.forumTopicPost.create
    .replace('{clubId}', String(clubId))
    .replace('{forumId}', String(forumId))
    .replace('{forumTopicId}', String(forumTopicId))
    .replace('{userId}', String(userId));

  return await api.post(baseUrl, payload)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } });
}

